import { mapDTO } from '@twistezo/ts-dto-mapper'

import { floatPercentToDTO } from 'utils/number'
import { Schema } from '../../../schema'
import { Variables } from './types'

export const toDTO = (from: Schema): Variables =>
  mapDTO<Schema, Variables>({ from }).transform((data: Schema): Variables => {
    const { allowActivitiesData, connectionSpeed, s2sTimeoutMultiplier, ...rest } = data

    return {
      ...rest,
      allowActivitiesData: allowActivitiesData.length > 0 ? allowActivitiesData : null,
      disablePrebidStackForUsersWithPoorInternetEnabled: Boolean(
        connectionSpeed.disablePrebidStack,
      ),
      maximumRttToEnablePrebidStack: connectionSpeed.maxRtt,
      s2sTimeoutMultiplier: floatPercentToDTO(s2sTimeoutMultiplier),
    }
  })
